var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.13502 8.84201C3.17992 8.88997 3.23383 8.92861 3.29367 8.95572C3.35351 8.98283 3.4181 8.99788 3.48376 9.00002C3.54941 9.00215 3.61485 8.99133 3.67632 8.96817C3.7378 8.945 3.7941 8.90995 3.84202 8.86501L7.50002 5.43501L11.158 8.86501C11.2548 8.95572 11.3837 9.00425 11.5163 8.99994C11.6489 8.99563 11.7743 8.93882 11.865 8.84201C11.9557 8.74521 12.0043 8.61634 11.9999 8.48375C11.9956 8.35116 11.9388 8.22572 11.842 8.13502L7.84202 4.38502C7.74935 4.29812 7.62707 4.24976 7.50002 4.24976C7.37298 4.24976 7.2507 4.29812 7.15802 4.38502L3.15802 8.13502C3.11007 8.17991 3.07143 8.23382 3.04432 8.29366C3.01721 8.3535 3.00216 8.41809 3.00002 8.48375C2.99788 8.54941 3.00871 8.61484 3.03187 8.67631C3.05504 8.73779 3.09009 8.79409 3.13502 8.84201Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/_chevron-up.91af3215afbbd21dc663f2c87c034f78.svg";
export { ForwardRef as ReactComponent };